// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GiMLn","toggleWrap":"styles_toggleWrap__2a7ne","content":"styles_content__3hbMG","selectAreaCode":"styles_selectAreaCode__2rZja"};